import { get } from 'object-path-immutable';
import {
  applyThemeInLocalizedBlock,
  calculateOverridePathsInLocalizedBlock,
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
};

const themeAdder = (content, selectedVariant, preserveOverrides) => {
  const { width, height } = get(content, PATHS.root) ?? {};
  return augmentedWrap(content)
    .updateStyle(
      PATHS.root,
      {
        theme: selectedVariant,
        ...(width && { width }),
        ...(height && { height }),
      },
      preserveOverrides
    )
    .value();
};

const overridesCalculator = ({ compiledTheme, content, path, pathName }) =>
  [
    calculateOverridePaths({
      compiledTheme,
      content,
      path: path ? `${path}.style` : PATHS.root,
      pathName,
      ignore: ['width', 'height'],
    }),
  ].flat();

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  applyThemeInLocalizedBlock(
    content,
    selectedVariant,
    preserveOverrides,
    themeAdder
  );

export const overrides = args =>
  calculateOverridePathsInLocalizedBlock(args, overridesCalculator);

export const extractStyles = content => ({
  $style: styleToThemeStyle({
    style: get(content, PATHS.root),
    ignore: ['width', 'height'],
  }),
});
